function init() {

    var cookie = $.cookie('.AlertDismissed');
    if (cookie != "true") {
        $('.alert').alert();
        $('.alert').show();
    } else {
        $('#close-alert').click();
        window.scrollTo(0, 0);
    }

    $('#close-alert').click(function () {
        $.cookie('.AlertDismissed', 'true');
        window.scrollTo(0, 0);
    });

}

export default {
    init
}